import { gql } from '__generated__';

export default gql(`
  mutation SetDefaultPaymentProfile($id: ID!) {
    setDefaultPaymentProfile(id: $id) {
      id
      mollie_connections {
        ...MollieConnectionFields
      }
    }
  }
`);
